import styled, { css } from 'styled-components';
import { Form } from 'antd';
import theme from 'styled-theming';

const FormItemMargin = theme('noMarginBottom', {
  true: css`
    margin-bottom: 0 !important;
  `,
});

const StyledFormItem = styled(Form.Item).attrs({
  colon: false,
})`
  .ant-form-item-required::before {
    display: none;
  }

  .ant-form-item-label {
    text-align: left;
  }

  ${FormItemMargin};
`;

export default StyledFormItem;
